// ============================================================
// Migration Error Pages — NotFound, Unauthorized, ServerError.
// Phase 5: Error UX with user-friendly fallback and retry paths.
// ============================================================

import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface ErrorPageProps {
  title: string;
  message: string;
  backLabel?: string;
  backPath?: string;
}

const MigrationErrorPage: React.FC<ErrorPageProps> = ({
  title,
  message,
  backLabel = 'Go to Migrations',
  backPath = '/migrations',
}) => {
  const navigate = useNavigate();
  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight={300}>
      <Paper sx={{ p: 4, maxWidth: 480, textAlign: 'center' }}>
        <Typography variant="h4" fontWeight="bold" color="text.disabled" mb={1}>
          {title}
        </Typography>
        <Typography variant="body1" color="text.secondary" mb={3}>
          {message}
        </Typography>
        <Box display="flex" gap={2} justifyContent="center">
          <Button variant="contained" onClick={() => navigate(backPath)}>{backLabel}</Button>
          <Button variant="outlined" onClick={() => navigate(-1 as any)}>Go Back</Button>
        </Box>
      </Paper>
    </Box>
  );
};

export const MigrationNotFoundPage: React.FC = () => (
  <MigrationErrorPage
    title="Not Found"
    message="The migration resource you requested does not exist or has been removed."
  />
);

export const MigrationUnauthorizedPage: React.FC = () => (
  <MigrationErrorPage
    title="Access Denied"
    message="You do not have permission to view this migration. Contact your administrator."
    backLabel="Go Home"
    backPath="/"
  />
);

export const MigrationServerErrorPage: React.FC = () => (
  <MigrationErrorPage
    title="Service Unavailable"
    message="The migration service is temporarily unavailable. Please try again in a few moments."
    backLabel="Retry"
    backPath="/migrations"
  />
);
